import React from "react";

const Vision = () => {
  return (
    <>
      <div className="text-5xl font-bold text-blue-600 mb-6 mt-6">Vision</div>
      <div className="text-2xl font-medium mb-8">
        Our vision is to foster a culture of innovation, creativity, <br />and entrepreneurship that drives sustainable 
        economic <br />growth and societal impact in India. We envision a future <br />where every aspiring entrepreneur has 
        the resources, <br />support, and opportunities needed to turn their ideas into <br />successful ventures, creating a 
        vibrant ecosystem of innovation <br />and prosperity.
      </div>
     
      <div className="bg-gray-100 p-6 rounded-lg shadow-md mb-8">
        <div className="text-3xl font-bold text-blue-700 mb-4">
          PASSION FRAMEWORK
        </div>
        <div className="text-xl font-medium">
          A 2-decade old research initiated as PASSION, a concept to help the jobless community and build entrepreneurship ecosystem. It evolved as a framework as part of a PhD Thesis by Dr. Prakash Sharma, who has 30+ years of experience in the IT industry. The framework has 7 Dimension and 28 process areas, and we actively engage senior thought leaders, technical leads, academicians to focus on practical research/pain points within their existing companies or experiences and build entrepreneurship-focused research papers/articles in any of chosen process areas. There are opportunities to cofound companies, initiate startup at absolute low cost and contribute to society. Our blog which explains entrepreneurship using stories and poems has over 98 country viewership. Our virtual incubation PCOMBINATOR has been benchmarked as one of the top 10% accelerator program with reference to competency development.
          <br />
          <br />
          <a href="https://www.linkedin.com/in/dr-prakash-sharma-330743a3/?originalSubdomain=in" className="text-blue-500 underline">Linkedin</a>
          <br />
          Look forward to active participation.
        </div>
      </div>
    </>
  );
};

export default Vision;